import { useEffect, useState } from "react";
import { motion } from "framer-motion";

// Saturday, October 2, 2027 — 7:00 AM (Accra / GMT). 5th Edition.
const TARGET = new Date("2027-10-02T07:00:00Z").getTime();

const pad = (n) => String(n).padStart(2, "0");

function getRemaining() {
  const diff = TARGET - Date.now();
  if (diff <= 0) return { done: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  return {
    done: false,
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center" data-testid={`countdown-${label.toLowerCase()}`}>
    <div className="relative min-w-[4.5rem] md:min-w-[7rem] rounded-2xl bg-white/10 border border-white/20 px-3 md:px-6 py-4 md:py-6 backdrop-blur-sm">
      <span className="font-serif font-light text-4xl md:text-7xl leading-none text-white tabular-nums">
        {pad(value)}
      </span>
    </div>
    <span className="mt-3 font-display text-[0.6rem] md:text-xs uppercase tracking-[0.22em] text-white/70">{label}</span>
  </div>
);

export default function Countdown() {
  const [t, setT] = useState(getRemaining());

  useEffect(() => {
    const id = setInterval(() => setT(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <section className="relative overflow-hidden py-16 md:py-24 px-5 md:px-10" data-testid="countdown-section">
      <div className="absolute inset-0 brand-gradient" />
      <div className="absolute inset-0 grain" />
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 h-[24rem] w-[24rem] rounded-full bg-white/10 blur-[120px] animate-floaty pointer-events-none" />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 max-w-[1100px] mx-auto text-center"
      >
        <p className="font-display text-xs uppercase tracking-[0.3em] text-white/80 mb-4">Choices &amp; Decisions 2027 · 5th Edition</p>
        <h2 className="font-serif font-light text-3xl md:text-5xl leading-tight text-white">
          Saturday, October 2, 2027
        </h2>
        <p className="mt-2 font-display text-sm md:text-base uppercase tracking-[0.2em] text-white/80">
          7:00 AM – 4:00 PM · Accra, Ghana
        </p>

        {t.done ? (
          <p className="mt-10 font-serif italic text-3xl md:text-5xl text-white">The day is here. Welcome home.</p>
        ) : (
          <div className="mt-10 flex items-start justify-center gap-3 md:gap-6">
            <Unit value={t.days} label="Days" />
            <span className="font-serif text-4xl md:text-7xl text-white/40 leading-none mt-3 md:mt-5">:</span>
            <Unit value={t.hours} label="Hours" />
            <span className="font-serif text-4xl md:text-7xl text-white/40 leading-none mt-3 md:mt-5">:</span>
            <Unit value={t.minutes} label="Minutes" />
            <span className="font-serif text-4xl md:text-7xl text-white/40 leading-none mt-3 md:mt-5">:</span>
            <Unit value={t.seconds} label="Seconds" />
          </div>
        )}

        <a
          href="sms:+233546080065?&body=C%26D"
          data-testid="countdown-register"
          className="mt-12 inline-flex rounded-full bg-[#1B0812] px-9 py-4 font-display text-sm uppercase tracking-[0.14em] font-bold text-cream transition-transform duration-300 hover:scale-105"
        >
          Free Entry — Text “C&amp;D” to 054 608 0065
        </a>
      </motion.div>
    </section>
  );
}
